import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "apexcharts-tooltip-title",
  style: {"font-family":"inherit","font-size":"12px","font-weight":"600","padding":"6px 10px","background":"rgba(0, 0, 0, 0.03)","border-bottom":"1px solid #eee","display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "调用量", -1)
const _hoisted_3 = {
  class: "apexcharts-tooltip-series-group",
  style: {"padding":"8px 10px","display":"flex !important","flex-direction":"column !important","gap":"6px"}
}
const _hoisted_4 = { style: {"display":"flex","align-items":"center","gap":"20px","flex":"0.5"} }
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = { style: {"font-size":"12px","color":"#5e6278"} }
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"space-between","gap":"20px","flex":"0.5"}
}
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = { style: {"font-size":"12px","color":"#5e6278"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            style: _normalizeStyle([{ backgroundColor: _ctx.colors[0] }, {"width":"8px","height":"8px","border-radius":"50%","margin-right":"8px"}])
          }, null, 4),
          _createElementVNode("span", _hoisted_6, " 当前: " + _toDisplayString(_ctx.currentDt), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.currentVal.toLocaleString()), 1)
        ])
      ]),
      (_ctx.compareVal !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                style: _normalizeStyle([{ backgroundColor: _ctx.colors[1] }, {"width":"8px","height":"8px","border-radius":"50%","margin-right":"8px"}])
              }, null, 4),
              _createElementVNode("span", _hoisted_9, " 对比: " + _toDisplayString(_ctx.compareDt), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.compareVal.toLocaleString()), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}